import { Injectable } from '@angular/core';
import { AssetManagerCriticalArea } from '@app/asset-manager/asset-manager-critical-area';
import { CriticalAreaService, ICriticalAreaDTO } from 'src/app/template/critical-area-window/critical-area.service';

@Injectable({
  providedIn: 'root'
})
export class CriticalAreaActionsService {

  constructor(
    private criticalAreaService: CriticalAreaService,
    private assetManagerCriticalArea: AssetManagerCriticalArea
  ) { }

  completeCriticalAreaAction(criticalAreaId: string, actionId: string) {
    this.criticalAreaService.getCriticalArea(criticalAreaId).subscribe({
      next: criticalArea => {
        this.executeCriticalAreaAction(criticalArea, actionId);
        
        // After updating, upsert the critical area
        this.criticalAreaService.saveCriticalArea(criticalArea).subscribe({
          next: () => {
            this.assetManagerCriticalArea.updateCriticalAreaProperties(criticalAreaId, criticalArea);
            console.log('Critical area updated successfully');
            // You can add any additional logic here, such as showing a success message
          },
          error: error => {
            console.error('Error updating critical area:', error);
            // Handle the error appropriately
          }
        }
        );
      },
      error: error => {
        console.error('Error fetching critical area:', error);
        // Handle the error appropriately
      }
    });
  }

  executeCriticalAreaAction(criticalArea: ICriticalAreaDTO, actionId: string): void {
    criticalArea.CriticalAreaActions?.forEach(action => {
      if (action.Id === actionId) {
        action.IsExecuted = true;
      }
    });
  }
}
